"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _calls = require("../../../icons-react/dialer/calls");
var ErrorState = function ErrorState(_ref) {
  var className = _ref.className,
    error = _ref.error;
  return /*#__PURE__*/_react["default"].createElement(StyledErrorState, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(StyledContent, null, /*#__PURE__*/_react["default"].createElement(_calls.Error, {
    width: 27
  }), /*#__PURE__*/_react["default"].createElement(StyledInfo, null, /*#__PURE__*/_react["default"].createElement("span", null, error))));
};
ErrorState.propTypes = {
  className: _propTypes["default"].string
};
ErrorState.defaultProps = {
  className: ''
};
var StyledErrorState = _styledComponents["default"].form.withConfig({
  displayName: "Error__StyledErrorState",
  componentId: "sc-hjl6k-0"
})(["background-image:linear-gradient(to left,#e50e5c,#ec8926);width:100%;height:65px;display:flex;font-size:14px;align-items:center;justify-content:space-between;"]);
var StyledContent = _styledComponents["default"].div.withConfig({
  displayName: "Error__StyledContent",
  componentId: "sc-hjl6k-1"
})(["align-items:center;display:flex;height:100%;justify-content:center;width:100%;"]);
var StyledInfo = _styledComponents["default"].div.withConfig({
  displayName: "Error__StyledInfo",
  componentId: "sc-hjl6k-2"
})(["color:#fff;margin-left:15px;span{font-size:17px;}"]);
var _default = exports["default"] = ErrorState;